import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Newspaper } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { Btn, Eyebrow, Section, SectionTitle, Lead } from "@/components/ui-kit/Kit";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";
import { fetchNews } from "@/lib/api";

export const UpdatesPreview = () => {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    fetchNews(3)
      .then((d) => alive && setItems(d.items || []))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Section className="bg-slate-50/70 py-24 sm:py-32" data-testid="updates-preview-section">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <Reveal>
          <Eyebrow>{t("home.updates.eyebrow")}</Eyebrow>
          <SectionTitle className="mt-6">{t("home.updates.title")}</SectionTitle>
          <Lead className="mt-5 max-w-xl">{t("home.updates.sub")}</Lead>
        </Reveal>
        <Reveal delay={0.1}>
          <Btn to="/news" variant="outline" data-testid="view-all-news">
            {t("cta.viewAll")} <ArrowRight className="h-4 w-4" />
          </Btn>
        </Reveal>
      </div>

      {items.length === 0 ? (
        <Reveal delay={0.1}>
          <div className="mt-12 grid gap-px border border-navy/10 bg-navy/10 md:grid-cols-3" data-testid="news-placeholders">
            {["Regulatory Update", "GPU Update", "Event"].map((label) => (
              <div key={label} className="bg-white p-8">
                <Newspaper className="h-6 w-6 text-navy/20" strokeWidth={1.4} />
                <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-grn">{label}</p>
                <p className="mt-4 text-sm leading-relaxed text-slate-500">{t("common.noContentYet")}</p>
              </div>
            ))}
          </div>
        </Reveal>
      ) : (
        <Stagger className="mt-12 grid gap-px border border-navy/10 bg-navy/10 md:grid-cols-3">
          {items.map((p, i) => (
            <StaggerItem key={p.slug || i} className="bg-white">
              <Link to="/news" className="group block h-full p-8" data-testid={`news-card-${i + 1}`}>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-grn">{p.category}</p>
                <h3 className="mt-5 font-display text-xl font-semibold leading-snug text-navy group-hover:text-grn">
                  {p.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-slate-600">{p.excerpt}</p>
                <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.18em] text-navy/40">
                  {p.published_at?.slice(0, 10)}
                </p>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      )}
    </Section>
  );
};
